import { QueryClient, QueryClientProvider as QueryClientProviderWrapper } from 'react-query';

import { IQueryClientProviderProps } from './query-client-provider.types';

const queryClient = new QueryClient();

export const QueryClientProvider = ({ children }: IQueryClientProviderProps): JSX.Element => (
  <QueryClientProviderWrapper client={queryClient}>{children}</QueryClientProviderWrapper>
);
